export default "__VITE_ASSET__BtDHPyt$__"